import { Injectable } from "@angular/core";
import { RxState } from "@rx-angular/state";
import { catchError, delay, map, of, shareReplay } from "rxjs";

import { LoggerService } from "../../logger/logger.service";
import { AiAgent } from "../models/ai-agents.interface";
import { AiAgentEnum } from "src/app/api/models/ai-agents/ai-agents.enum";
import { ApiClientAiAgentsService } from "src/app/api/api-client-ai-agents.service";
import { AiAgentsState } from "./ai-agents.state";

@Injectable({
    providedIn: 'root'
})
export class AiAgentsStore extends RxState<AiAgentsState> {

    private readonly loggerName: string = 'AiAgentsStore';

    private readonly initState = {
        empty: undefined,
        loading: true,
        agents: undefined,
    } as AiAgentsState;

    // Initial API call (only called once)
    private readonly _agents$ = this.apiClientAiAgentsService.getAiAgents().pipe(
        delay(100),
        map(agents => new Map(agents.map(agent => ([agent.miraId, agent as AiAgent])))),
        catchError(err => {
            console.error(err);
            this.logger.error(this.loggerName, err?.message ?? String(err));
            return of(new Map());
        }),
        shareReplay(1)
    );

    constructor(
        private logger: LoggerService,
        private apiClientAiAgentsService: ApiClientAiAgentsService
    ) {
        super();
        this.set(this.initState);
    }

    loadAgents(): void {
        this.connect('agents', this._agents$);
        this.connect('loading', this._agents$.pipe(map(() => false)));
        this.connect('empty', this._agents$.pipe(map(agents => !agents?.size)));
    }

    updateAgent(miraId: AiAgentEnum, agent: AiAgent): void {
        this.set((state) => ({
            agents: new Map(state.agents).set(miraId, agent),
        }));
    }
}
